import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import _ from 'lodash';

import ChannelCard from 'components/ChannelCard';
import UserCard from 'components/UserCard';
import Dropdown from 'components/Dropdown';
import Menu, { MenuItem } from 'components/Menu';
import { DeleteIcon, DownChevronIcon } from 'components/Svg';
import { REMOVE_BOT_ACCOUNT } from 'store/models/Account';
import { DeleteIconButton } from 'components/Button';

export const UserSelectItem = ({user, showDelete, onSelect, onDelete, ...props}) => {
  let onDeleteClick = e => {
    e.stopPropagation();
    onDelete?.(user._id, user) 
  }
  return (
    <MenuItem className="g-user-select-item" onClick={() => onSelect?.(user._id, user)} {...props}>
      <UserCard user={user} />
      { showDelete &&
      <div className="select-action"><DeleteIconButton color="light" onClick={onDeleteClick} /></div>}
    </MenuItem>)
}

export const UserSelect = ({ users = [], showDelete, className, size = 'm', selected, onChange, onDelete,...props}) => {
  let onSelect = (userId, user) => onChange?.(userId, user)
  let selectedUser = _.find(users, { _id: selected });

  return (
    <Menu 
      target={({className: targetClassName, ...props}) => (
        <div className={cx("g-user-select", className, size, targetClassName)} {...props}>
          <UserCard user={selectedUser} size={size} />
          <DownChevronIcon />
        </div>
      )}
      position={'top left'}>
      <div className="g-user-select-dropdown">
        {_.map(users, user => 
          <UserSelectItem 
            key={user?._id} 
            user={user} 
            showDelete={showDelete} 
            onSelect={onSelect} 
            onDelete={onDelete} />)}
      </div>
    </Menu>)
}
export default UserSelect;